// 고객대시보드 사진 저장 — 개별 뷰어(photo-organizer ShareLinkMain)의 저장 방식을 대시보드로 옮긴 것.
// 개별 사진: 터치 기기는 Web Share(갤러리 저장 공유시트) 우선, 아니면 Content-Disposition 헤더 방식 앵커 다운로드.
// 여러 장: 서버가 만든 zip 하나를 앵커로 내려받는다(개별 다운로드를 장수만큼 반복하면 확인창이 반복되고 Web Share 개수·용량
// 제한에 걸린다 — 카카오톡 인앱브라우저 등 실기기 검증됨).

const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

// <a download> 속성은 카카오톡 인앱브라우저 등에서 문제(iOS 미지원)가 있어 서버가 Content-Disposition: attachment 로
// 내려주는 헤더 방식(카카오 공식 권장)을 쓴다. download 속성은 헤더가 무시되는 환경의 폴백으로 함께 둔다.
function withDownloadParam(url: string): string {
  return url + (url.includes('?') ? '&' : '?') + 'download=1';
}

export function triggerAnchorDownload(url: string, filename: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/** 사진 1장 저장 — 원본 URL(없으면 썸네일). */
export async function savePhoto(url: string, filename: string): Promise<void> {
  if (isTouchDevice() && typeof navigator.share === 'function') {
    try {
      const res = await fetch(url, { credentials: 'include' });
      const blob = await res.blob();
      const file = new File([blob], filename, { type: blob.type || 'image/jpeg' });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file] });
        return;
      }
    } catch {
      /* 공유시트 실패·취소 → 앵커 다운로드로 */
    }
  }
  triggerAnchorDownload(withDownloadParam(url), filename);
}

/**
 * zip 파일명 — 서버(sv-photo PhotoZipWriter.buildZipFilename)와 같은 형식 "[인디포토] {현장명} 공유사진-yyyyMMdd.zip".
 * Safari 는 서버 Content-Disposition 보다 <a download> 속성값을 우선하므로 같은 이름을 미리 만들어 둔다.
 */
export function buildZipFilename(siteName: string | null | undefined, now: Date = new Date()): string {
  const title = `${siteName ? `${siteName} ` : ''}공유사진`.replace(/[\/:*?"<>|\x00-\x1f]/g, ' ').trim();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `[인디포토] ${title}-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}.zip`;
}
